const restApiV1Host = process.env.REACT_APP_REST_API_V1_HOST;
// const restApiV2Host = process.env.REACT_APP_REST_API_V2_HOST;
// const fullDomainName = process.env.REACT_APP_DEPLOYMENT_DOMAIN_NAME;
const deploymentDomainName = process.env.REACT_APP_DEPLOYMENT_DOMAIN_NAME;
const deploymentId = process.env.REACT_APP_DEPLOYMENT_ID || "dev";
const apiHostname = deploymentDomainName
  ? `${deploymentId === "dev" ? "api" : "restapi"}.${deploymentDomainName}`
  : restApiV1Host || "";

const perspectiveHostname = apiHostname.replace(
  /(api\.|restapi\.)/,
  "perspectiveserver."
);

const chatGatewayHostname = apiHostname.replace(
  /(api\.|restapi\.)/,
  "chatgateway."
);

const chatGatewayProtocol =
  process.env.REACT_APP_CHAT_GATEWAY_PROTOCOL_OVERRIDE || "https://";
const chatGatewayHost =
  process.env.REACT_APP_CHAT_GATEWAY_HOST_OVERRIDE || chatGatewayHostname;
const nucleusPlatformOrigin =
  process.env.REACT_APP_NUCLEUS_PLATFORM_ORIGIN_OVERRIDE ||
  `${chatGatewayProtocol}${chatGatewayHost}`;
const nucleusStreamPath =
  process.env.REACT_APP_NUCLEUS_STREAM_PATH_OVERRIDE ||
  "/nucleusapi/turns/stream";

export const apiConfig = {
  backendGateway: {
    protocol: process.env.REACT_APP_BACKEND_PROTOCOL || "https://",
    host: process.env.REACT_APP_BACKEND_HOST || apiHostname,
    path: "",
    apiUrl: `${process.env.REACT_APP_BACKEND_PROTOCOL || "https://"}${
      process.env.REACT_APP_BACKEND_HOST || apiHostname
    }`,
    graphqlPath: "/backendgateway",
  },
  perspectiveServer: {
    protocol:
      process.env.REACT_APP_PERSPECTIVE_PROTOCOL_OVERRIDE ||
      process.env.REACT_APP_BACKEND_PROTOCOL ||
      "https://",
    host:
      process.env.REACT_APP_PERSPECTIVE_HOST_OVERRIDE || perspectiveHostname,
    path:
      process.env.REACT_APP_PERSPECTIVE_PATH_OVERRIDE === undefined
        ? ""
        : process.env.REACT_APP_PERSPECTIVE_PATH_OVERRIDE,
    graphqlPath: "/graphql",
    wsPath: "/ws",
  },
  chatGateway: {
    protocol: chatGatewayProtocol,
    host: chatGatewayHost,
  },
  nucleusPlatform: {
    transport:
      process.env.REACT_APP_NUCLEUS_TRANSPORT === "platform"
        ? ("platform" as const)
        : ("legacy" as const),
    streamUrl: `${nucleusPlatformOrigin.replace(/\/$/, "")}/${nucleusStreamPath.replace(
      /^\//,
      ""
    )}`,
  },
  region: process.env.REACT_APP_AWS_PROJECT_REGION,
};
